import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'; // 引入路由配置
import { Loading } from 'element-ui'
import { WeToolbar, WeEditable, WeEditor } from 'wangeditor5-for-vue2'
import '@wangeditor/editor/dist/css/style.css'
Vue.use(ElementUI);
Vue.use(WeToolbar)
Vue.use(WeEditable)
Vue.use(WeEditor)
Vue.config.productionTip = false
// 在Vue原型上挂载方法（可选）
Vue.prototype.$loading = Loading.service

// ========== Token监控：追踪token何时被清除 ==========
const originalSetItem = localStorage.setItem.bind(localStorage);
const originalRemoveItem = localStorage.removeItem.bind(localStorage);
const originalClear = localStorage.clear.bind(localStorage);

localStorage.setItem = function(key, value) {
  if (key === 'token') {
    console.log('%c[Token监控] setItem:', 'color: blue; font-weight: bold', value ? '设置新token' : '设置空值!');
    if (!value) {
      console.trace('[Token监控] 设置空token的调用栈');
    }
  }
  return originalSetItem(key, value);
};

localStorage.removeItem = function(key) {
  if (key === 'token') {
    console.log('%c[Token监控] removeItem: token被删除!', 'color: red; font-weight: bold');
    console.trace('[Token监控] 删除token的调用栈');
  }
  return originalRemoveItem(key);
};

localStorage.clear = function() {
  console.log('%c[Token监控] clear: localStorage被清空!', 'color: red; font-weight: bold');
  console.trace('[Token监控] 清空localStorage的调用栈');
  return originalClear();
};

// 监听storage事件（其他标签页的变化）
window.addEventListener('storage', (e) => {
  if (e.key === 'token') {
    console.log('%c[Token监控] storage事件: token在其他标签页被修改!', 'color: orange; font-weight: bold');
    console.log('旧值:', e.oldValue ? '存在' : '空');
    console.log('新值:', e.newValue ? '存在' : '空');
  }
});

// 定时检查token状态
setInterval(() => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('%c[Token监控] 定时检查: token不存在!', 'color: red');
  }
}, 5000); // 每5秒检查一次

console.log('[Token监控] 已启动，当前token状态:', localStorage.getItem('token') ? '存在' : '不存在');
// ========== Token监控结束 ==========

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
